import TabsButton from './TabsButton';

export default TabsButton;
